module.exports = __webpack_public_path__ + "img/创客中国.5450e038.png";